exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes detail-data-v-b7626674{0%{transform:rotateX(90deg);opacity:0}to{transform:rotateX(0);opacity:1}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b7626674","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/next/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/_eng/globals/dtable.vue
// module id = 1684
// module chunks = 142